import { POSTPaymentDetails } from "@/apis/providers/requests";
import { PAYMENT_TYPES, PaymentPayload } from "@/apis/providers/types/provider.types";
import { useAppAlert } from "@/app/AppAlertProvider";
import { parseRequestError } from "@/app/common/utilities";
import { selectProgramID } from "@/storage/program_settings/programSettingsSlice";
import { useMutation } from "@tanstack/react-query";
import { useSelector } from "react-redux";
import CreateReimbursementForm, { ReimbursementDetails } from "./create_reimbursement_form";
import { ReimbursementStep } from './reimbursements.constants';
import ProviderReimbursementSuccess from "./reimbursement_successful.page";

export function CreateReimbursementPage() {
  const { fireAlert } = useAppAlert()
  const programId = useSelector(selectProgramID)
  const mutation = useMutation({
    mutationFn: (payload: PaymentPayload) => POSTPaymentDetails(payload),
    onSuccess: () => {
    },
    onError: (error) => {
      const parsedError = parseRequestError(error)

      fireAlert({
        variant: 'error',
        message: parsedError.message,
      })
    },
  })

  function handleReimbursementSubmit(data: ReimbursementDetails) {
    mutation.mutate({
      comments: data.comments,
      files: data.documents.map((file) => ({
        document_type: 1,
        file_name: file,
      })),
      global_expense_categories: data.expenseCategories.map((category) => ({
        id: category.id,
        amount: category.amount,
      })),
      invoice_quote: data.invoiceNumber,
      program_id: programId,
      type: PAYMENT_TYPES.REIMBURSEMENT,
      purses: data.purses.map((purse) => ({
        purse_id: purse.purse_id,
        amount: purse.amount,
      })),
      store_name: data.store_name,
    })
  }


  if (mutation.status === "success") {
    return (
      <div className="max-w-lg mx-auto">

        <ProviderReimbursementSuccess />
      </div>
    )
  }


  return (
    <CreateReimbursementForm
      startStep={ReimbursementStep.ADD_DETAILS}
      mutationStatus={mutation.status}
      onSubmit={handleReimbursementSubmit}
    />
  )
}